<template>
  <v-row no-gutters class="p0-16">
    <v-col cols="2">
      <v-checkbox
        v-model="newSession.allDay"
        label="Tous les jours"
        color="third"
        @change="changeCheckboxValue"
      />
    </v-col>
  </v-row>
</template>

<script>
import { inject, watch, computed } from '@vue/composition-api';
import { fromUnixTime, format } from 'date-fns';
import { isObjectEmpty } from '@/helpers/utils';

export default {
  setup () {
    const newSession = inject('newSession');
    const sessionReplica = inject('sessionReplica');
    const originalSessionReplica = inject('originalSessionReplica');
    const oldSessionDetail = inject('oldSessionDetail');
    const editable = inject('editable');

    const changeCheckboxValue = value => {
      newSession.value.allDay = value;
    };

    const allDay = computed(() => newSession.value.allDay);

    watch(allDay, () => {
      if (!allDay.value) {
        if (!editable.value) {
          sessionReplica.value = { ...originalSessionReplica.value };
          return;
        }

        if (oldSessionDetail.value.replica) {
          sessionReplica.value = { ...oldSessionDetail.value.replica, isReplica: !!oldSessionDetail.value.replica && !isObjectEmpty(oldSessionDetail.value.replica), replica_end_date: format(fromUnixTime(oldSessionDetail.value.end_recurring_date), 'yyyy-MM-dd') };
          return;
        }

        sessionReplica.value = { ...originalSessionReplica.value, isReplica: !!oldSessionDetail.value.replica && !isObjectEmpty(oldSessionDetail.value.replica) };
        return;
      }

      if (allDay.value && !sessionReplica.value.isReplica) {
        sessionReplica.value = {
          isReplica: true,
          replica_type: 'REPLICATION_SIMPLE',
          replica_option: 'ALL_JOURS',
          replica_interval: [],
          replica_weeks: [],
          replica_end_date: format(fromUnixTime(newSession.value.end_date), 'yyyy-MM-dd'),
          excludeHolidays: false
        };
      }
    });

    return { newSession, changeCheckboxValue };
  }
};
</script>
